var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"LoginLayout"}},[_c('AppHeader'),_c('section',{attrs:{"id":"main"}},[_c('aside'),_c('div',{staticClass:"clsSidebar"}),_c('section',{attrs:{"id":"content"}},[_c('div',{staticClass:"container"},[_c('transition',{attrs:{"name":"fade","mode":"out-in"}},[_vm._t("default")],2)],1)])]),_c('AppFooter')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }